//incluir checkbox para prospecção

import React, { useEffect, useState } from 'react';
import axios from 'axios'; // Import axios
import SearchIcon from '@mui/icons-material/Search'; // Import the SearchIcon
import { Autocomplete, TextField } from '@mui/material';
import './Cadastro.css'; // Import the CSS file for styling
import { getAccessToken, getDepartment } from '../../utils/storage'; // Import the function to get the access token

function formatCNPJ(value: string) {
  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{2})(\d)/, '$1.$2');
  value = value.replace(/(\d{3})(\d)/, '$1.$2');
  value = value.replace(/(\d{3})(\d)/, '$1/$2');
  value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  return value;
}

type ClienteData = {
  id_icone?: string;
  razao_social: string;
  [key: string]: any; // Allow additional properties

};

const Cadastro = () => {
  // const [showWarningForm, setShowWarningForm] = useState(false);
  const [allData, setAllData] = useState<ClienteData[]>([]); // Use the defined type for allData
  const [searchTerm, setSearchTerm] = useState(''); // State for search input
  const [consultoresFinanceiros, setConsultoresFinanceiros] = useState<string[]>([]);
  const [consultoresComerciais, setConsultoresComerciais] = useState<string[]>([]);
  const department = getDepartment();
  const canRegisterClient = ['Developer', 'Gestor', 'Diretor', 'Comercial'].includes(department || '');




  const [formData, setFormData] = useState({
    uf: '',
    cep: '',
    cnpj: '',
    pais: '',
    email: '',
    porte: '',
    bairro: '',
    numero: '',
    municipio: '',
    logradouro: '',
    cnae_fiscal: 0,
    complemento: '',
    razao_social: '',
    nome_fantasia: '',
    capital_social: '',
    ddd_telefone_1: '',
    ddd_telefone_2: '',
    representante_legal_1: '',
    cpf_representante_legal_1: '',
    representante_legal_2: '',
    cpf_representante_legal_2: '',
    natureza_juridica: '',
    opcao_pelo_simples: false,
    cnae_fiscal_descricao: '',
    data_situacao_cadastral: null,
    descricao_situacao_cadastral: '',
    descricao_identificador_matriz_filial: '',

    numero_funcionarios: 0,

    ponto_apoio: '',
    perfil: '',
    area_atuacao: '',
    segmento: '',
    numero_reunioes: 0,
    status: '',
    data_contratacao_fast: null,
    data_saida_fast: null,
    nome_ponte: '',
    consultor_comercial: '',
    consultor_financeiro: '',
    analista: '',
    sinal: '',
    motivo_sinal: '',
    analista_responsável_sinal: '',
    parceiro: false,
    justificativa_parceria: '',
    status_parceria: '',
    resultados_parceria: '',
    descricao_avaliacao_parceria: '',
    prospeccao: false,
    responsavel_prospeccao: '',
    temperatura: '',
    data_previsao_fechamento: null,
    data_retorno: null,
    status_prospeccao: '',
    indicacao_cliente: false,
    quem_indicou: '',
    status_indicacao: '',
    nome_contato_indicacao: '',
    observacao_indicacao: '',
    SLA: '',
    data_sla: null,
    valor_fatura_cliente: '',
    grupo_economico_cliente: '',
    coluna_mae: '',
    data_inicio_parceria: null,
    padrinho_parceria: '',
    avaliacao_parceria: '',
    cliente_fast: true,
    id_contrato: 0,
    id_icone: 0,
    comercial: '',
    cnae_secundario: null,
    origem_lead: '',
    data_reajuste_financeiro: null,
    porcentagem_reajuste_financeiro: 0,
    empresa_contratada: 'Prise',
    vencimento_fatura_1: 0,
    vencimento_fatura_2: 0,
    observacao_fatura: '',
    indicacao_lead: '',
    comissao_indicacao: 0,
    comissao_fechamento: 0,
  });


  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/loja`, {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`, // Add bearer token
          },
        });
        setAllData(response.data); // Store all objects
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchConsultores = async () => {
      try {
        const token = getAccessToken();
        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };

        const [comercialResponse, consultorResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/login/department/username/Comercial`, config),
          axios.get(`${process.env.REACT_APP_API_URL}/login/department/username/Consultor`, config),
        ]);

        const comercialList = (Array.isArray(comercialResponse.data) ? comercialResponse.data : [])
          .map((item: { user?: string }) => item?.user)
          .filter((user): user is string => Boolean(user));

        const consultorList = (Array.isArray(consultorResponse.data) ? consultorResponse.data : [])
          .map((item: { user?: string }) => item?.user)
          .filter((user): user is string => Boolean(user));

        setConsultoresComerciais(comercialList);
        setConsultoresFinanceiros(consultorList);
      } catch (error) {
        console.error('Erro ao buscar lista de consultores/comerciais:', error);
      }
    };

    fetchConsultores();
  }, []);

  const handleSearch = async (term: string) => {
    setSearchTerm(term); // Update the search term
    const foundItem = allData.find((item) =>
      item.razao_social.toLowerCase().includes(term.toLowerCase())
    );
    if (foundItem) {
      const validKeys = Object.keys(formData); // Get valid keys from formData
      const filteredItem = Object.keys(foundItem)
        .filter((key) => validKeys.includes(key)) // Only include keys that exist in formData
        .reduce((obj, key) => {
          obj[key] = foundItem[key];
          return obj;
        }, {} as any);
      setFormData({ ...formData, ...filteredItem }); // Update form values

      // Fetch contratos for the found client
      try {
        
      } catch (error) {
        console.error('Erro ao buscar contratos:', error);
        alert('Erro ao buscar contratos do cliente.');
      }
    } else {
      setFormData({ ...formData }); // Reset formData if no match
      // setContratos([]); // Limpa os contratos se nenhum cliente for encontrado
    }
  };

  const handleCnpjBlur = async () => {
    if (formData.cnpj) {
      try {
        // Remove formatting for API call
        const cnpjNumbers = formData.cnpj.replace(/\D/g, '');
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const response = await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpjNumbers}`);
        const data = response.data;

        // Converter capital_social do CNPJ API (number) para string de dígitos
        const formatCapitalSocialToDigits = (val: number) => {
          if (val && val > 0) {
            return Math.round(val * 100).toString();
          }
          return '';
        };

        // Atualiza os campos do formulário com os dados retornados
        setFormData({
          ...formData,
          razao_social: data.razao_social || '',
          nome_fantasia: data.nome_fantasia || '',
          logradouro: data.logradouro || '',
          numero: data.numero || '',
          bairro: data.bairro || '',
          municipio: data.municipio || '',
          uf: data.uf || '',
          cep: data.cep || '',
          complemento: data.complemento || '',
          natureza_juridica: data.natureza_juridica || '',
          capital_social: formatCapitalSocialToDigits(data.capital_social),
          cnae_fiscal: data.cnae_fiscal || 0,
          cnae_fiscal_descricao: data.cnae_fiscal_descricao || '',
          pais: data.pais || '',
          ddd_telefone_1: data.ddd_telefone_1 || '',
          ddd_telefone_2: data.ddd_telefone_2 || '',
          representante_legal_1: data.representante_legal_1 || '',
          cpf_representante_legal_1: data.cpf_representante_legal_1 || '',
          representante_legal_2: data.representante_legal_2 || '',
          cpf_representante_legal_2: data.cpf_representante_legal_2 || '',
          email: data.email || '',
          porte: data.porte || '',
          opcao_pelo_simples: data.opcao_pelo_simples || false,
          descricao_situacao_cadastral: data.descricao_situacao_cadastral || '',
          descricao_identificador_matriz_filial: data.descricao_identificador_matriz_filial || '',
        });
      } catch (error) {
        console.error('Erro ao buscar dados do CNPJ:', error);
        alert('Erro ao buscar dados do CNPJ. Verifique o número digitado.');
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;

    let processedValue = value;
    
    // Apply CNPJ formatting
    if (name === 'cnpj') {
      processedValue = formatCNPJ(value);
    }

    setFormData({
      ...formData,
      [name]: type === 'checkbox'
        ? (e.target as HTMLInputElement).checked
        : type === 'date' && processedValue === ''
          ? null // Envia null para campos de data vazios
          : type === 'number'
            ? Number(processedValue)
            : processedValue,
    });
  };



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!canRegisterClient) {
      alert('Você não tem permissão para cadastrar novos clientes. Apenas Developer, Gestor, Diretor e Comercial podem realizar esta ação.');
      return;
    }
    
    const token = getAccessToken();

    try {
      // Converter valor_fatura_cliente (string com dígitos) para double (ex: 1113,58)
      const valorFaturaDigits = (typeof formData.valor_fatura_cliente === 'string' ? formData.valor_fatura_cliente : '').replace(/\D/g, '');
      let valorFaturaNumber = 0;
      if (valorFaturaDigits.length > 0) {
        valorFaturaNumber = parseInt(valorFaturaDigits, 10) / 100;
      }
      
      // Converter capital_social (string com dígitos) para double (ex: 1113,58)
      const capitalSocialDigits = (typeof formData.capital_social === 'string' ? formData.capital_social : '').replace(/\D/g, '');
      let capitalSocialNumber = 0;
      if (capitalSocialDigits.length > 0) {
        capitalSocialNumber = parseInt(capitalSocialDigits, 10) / 100;
      }
      
      const payload = {
        ...formData,
        cliente_fast: true,
        // Remove caracteres especiais do CNPJ antes de enviar para a API
        cnpj: formData.cnpj.replace(/\D/g, ''),
        valor_fatura_cliente: valorFaturaNumber,
        capital_social: capitalSocialNumber,
        data_criacao: new Date().toISOString(),
        data_alteracao: new Date().toISOString(),
      };

      // Convert empty date strings to null
      const dateFields = [
        'data_situacao_cadastral',
        'data_contratacao_fast', 
        'data_saida_fast',
        'data_reajuste_financeiro'
      ];
      
      dateFields.forEach(field => {
        if ((payload as any)[field] === '') {
          (payload as any)[field] = null;
        }
      });

      await axios.post(`${process.env.REACT_APP_API_URL}/loja`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert('Cadastro realizado com sucesso!');
      
      // Limpa o formulário após cadastro bem-sucedido
      handleNew();
    } catch (error: any) {
      if (error.response && error.response.status === 409) {
        alert('Cliente já cadastrado');
      } else {
        console.error('Erro ao cadastrar:', error);
        alert('Erro ao realizar o cadastro. Verifique os dados e tente novamente.');
      }
    }
  };

  const handleNew = () => {
    setFormData({
      uf: '',
      cep: '',
      cnpj: '',
      pais: '',
      email: '',
      porte: '',
      bairro: '',
      numero: '',
      municipio: '',
      logradouro: '',
      cnae_fiscal: 0,
      complemento: '',
      razao_social: '',
      nome_fantasia: '',
      capital_social: '',
      ddd_telefone_1: '',
      ddd_telefone_2: '',
      representante_legal_1: '',
      cpf_representante_legal_1: '',
      representante_legal_2: '',
      cpf_representante_legal_2: '',
      natureza_juridica: '',
      opcao_pelo_simples: false,
      cnae_fiscal_descricao: '',
      data_situacao_cadastral: null,
      descricao_situacao_cadastral: '',
      descricao_identificador_matriz_filial: '',

      numero_funcionarios: 0,

      ponto_apoio: '',
      perfil: '',
      area_atuacao: '',
      segmento: '',
      numero_reunioes: 0,
      status: '',
      data_contratacao_fast: null,
      data_saida_fast: null,
      nome_ponte: '',
      consultor_comercial: '',
      consultor_financeiro: '',
      analista: '',
      sinal: '',
      motivo_sinal: '',
      analista_responsável_sinal: '',
      parceiro: false,
      justificativa_parceria: '',
      status_parceria: '',
      resultados_parceria: '',
      descricao_avaliacao_parceria: '',
      prospeccao: false,
      responsavel_prospeccao: '',
      temperatura: '',
      data_previsao_fechamento: null,
      data_retorno: null,
      status_prospeccao: '',
      indicacao_cliente: false,
      quem_indicou: '',
      status_indicacao: '',
      nome_contato_indicacao: '',
      observacao_indicacao: '',
      SLA: '',
      data_sla: null,
      valor_fatura_cliente: '',
      grupo_economico_cliente: '',
      coluna_mae: '',
      data_inicio_parceria: null,
      padrinho_parceria: '',
      avaliacao_parceria: '',
      cliente_fast: true,
      id_contrato: 0,
      id_icone: 0,
      comercial: '',
      cnae_secundario: null,
      origem_lead: '',
      data_reajuste_financeiro: null,
      porcentagem_reajuste_financeiro: 0,
      empresa_contratada: '',
      vencimento_fatura_1: 0,
      vencimento_fatura_2: 0,
      observacao_fatura: '',
      indicacao_lead: '',
      comissao_indicacao: 0,
      comissao_fechamento: 0,
    })
  };

  // const handleEmitirAlerta = async () => {
  //   if (!formData.cnpj) {
  //     alert('Nenhum cliente selecionado para emitir alerta.');
  //     return;
  //   }

  //   const token = getAccessToken();

  //   try {
  //     const response = await axios.patch(
  //       `${process.env.REACT_APP_API_URL}/loja/update/${formData.cnpj}`,
  //       formData, // Envia os dados atualizados do cliente
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     alert('Alerta emitido com sucesso!');
  //   } catch (error) {
  //     console.error('Erro ao emitir alerta:', error);
  //     alert('Erro ao emitir alerta. Verifique os dados e tente novamente.');
  //   }
  // };


  return (
    <form onSubmit={handleSubmit} className="cadastro-form">
      <div className="form-header">
        <button type="button" className="new-button" onClick={handleNew}>
          Novo
        </button>
      </div>
      <div className="search-bar">
        <SearchIcon className="search-icon" />
        <input
          type="text"
          placeholder=  "Pesquisar por Razão Social..."
          className="search-input"
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)} // Trigger search on every input change
        />
      </div>

      {/* <div className="form-group warning-icon-container">
        <WarningIcon
          className="warning-icon"
          onClick={() => setShowWarningForm(!showWarningForm)} // Toggle the warning form
        />
      </div>
      {showWarningForm && (
        <div className="warning-form">
          <div className="form-group">
            <select
              name="sinal"
              value={formData.sinal}
              onChange={handleChange}
              className="select-input"
            >
              <option value="Sinal Verde">Sinal Verde</option>
              <option value="Sinal Amarelo">Sinal Amarelo</option>
              <option value="Sinal Vermelho">Sinal Vermelho</option>
            </select>
          </div>
          <div className="form-group motivo-sinal-container">
            <input
              name="motivo_sinal"
              value={formData.motivo_sinal}
              onChange={handleChange}
              placeholder="Motivo Sinal"
            />
            <div className="button-group">
              <button
                type="button"
                className="action-button"
                onClick={() => alert('Demanda do Analista acionada!')}
              >
                Demanda do Analista
              </button>
              <button
                type="button"
                className="action-button"
                onClick={() => alert('Overdelivery acionado!')}
              >
                Overdelivery
              </button>
            </div>
          </div>


          <div className="form-group">
            <input
              name="analista_responsável_sinal"
              value={formData.analista_responsável_sinal}
              onChange={handleChange}
              placeholder="Colaborador Responsável"
            />
          </div>




          <div className="form-group">
            <button
              type="button"
              className="alert-button"
              onClick={handleEmitirAlerta}
            >
              Emitir Alerta
            </button>
          </div>
        </div>
      )} */}

        <div className="form-group">
          <label>CNPJ:</label>
          <input 
            type="text" 
            name="cnpj" 
            value={formData.cnpj} 
            onChange={handleChange} 
            onBlur={handleCnpjBlur} 
            placeholder="00.000.000/0000-00"
            maxLength={18}
          />
        </div>
        <div className="form-group">
          <label>Consultor Comercial:</label>
          <Autocomplete
            freeSolo
            options={consultoresComerciais}
            value={formData.consultor_comercial}
            onChange={(_, newValue) => {
              setFormData((prev) => ({ ...prev, consultor_comercial: newValue || '' }));
            }}
            onInputChange={(_, newInputValue) => {
              setFormData((prev) => ({ ...prev, consultor_comercial: newInputValue || '' }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Selecione ou digite o consultor comercial"
                size="small"
                fullWidth
              />
            )}
          />
        </div>
        <div className="form-group">
          <label>Consultor Financeiro:</label>
          <Autocomplete
            freeSolo
            options={consultoresFinanceiros}
            value={formData.consultor_financeiro}
            onChange={(_, newValue) => {
              setFormData((prev) => ({ ...prev, consultor_financeiro: newValue || '' }));
            }}
            onInputChange={(_, newInputValue) => {
              setFormData((prev) => ({ ...prev, consultor_financeiro: newInputValue || '' }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Selecione ou digite o consultor financeiro"
                size="small"
                fullWidth
              />
            )}
          />
        </div>
  
        <div className="form-group">
          <label>Ponto de Apoio:</label>
          <input type="text" name="ponto_apoio" value={formData.ponto_apoio} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Perfil do Ponto de Apoio:</label>
          <input type="text" name="perfil" value={formData.perfil} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Área de Atuação:</label>
          <select 
            name="area_atuacao" 
            value={formData.area_atuacao} 
            onChange={handleChange}
            className="select-input"
          >
            <option value="" disabled>Selecione a área de atuação</option>
            <option value="industria">Indústria</option>
            <option value="comercio">Comércio</option>
            <option value="servicos">Serviços</option>
            <option value="hibrido">Híbrido</option>
          </select>
        </div>
        <div className="form-group">
          <label>Segmento:</label>
          <input type="text" name="segmento" value={formData.segmento} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Número de Reuniões:</label>
          <input type="number" name="numero_reunioes" value={formData.numero_reunioes} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Status:</label>
          <input type="text" name="status" value={formData.status} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Data Contratação Fast:</label>
          <input
            type="date"
            name="data_contratacao_fast"
            value={formData.data_contratacao_fast || ''} // Converte null para string vazia
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Data Saída Fast:</label>
          <input
            type="date"
            name="data_saida_fast"
            value={formData.data_saida_fast || ''} // Converte null para string vazia
            onChange={handleChange}
          />
        </div>
       


        <div className="form-group">
          <label>Valor Fatura Cliente (R$):</label>
          <input
            type="text"
            name="valor_fatura_cliente"
            value={(() => {
              let digits = (typeof formData.valor_fatura_cliente === 'string' ? formData.valor_fatura_cliente : '').replace(/\D/g, '');
              if (!digits) return 'R$ 0,00';
              let intVal = parseInt(digits, 10);
              let cents = intVal % 100;
              let reais = Math.floor(intVal / 100);
              return `R$ ${reais.toLocaleString('pt-BR')},${cents.toString().padStart(2, '0')}`;
            })()}
            style={{
              textAlign: 'right',
              fontVariantNumeric: 'tabular-nums'
            }}
            onChange={() => {}}
            onKeyDown={e => {
              if (e.ctrlKey || e.metaKey || e.altKey) return;
              if (e.key === 'Backspace') {
                const prev = typeof formData.valor_fatura_cliente === 'string' ? formData.valor_fatura_cliente : '';
                const newDigits = prev.slice(0, -1);
                setFormData({ ...formData, valor_fatura_cliente: newDigits });
                e.preventDefault();
                return;
              }
              if (/^[0-9]$/.test(e.key)) {
                const prev = typeof formData.valor_fatura_cliente === 'string' ? formData.valor_fatura_cliente : '';
                if (prev.length < 13) {
                  setFormData({ ...formData, valor_fatura_cliente: prev + e.key });
                }
                e.preventDefault();
                return;
              }
              e.preventDefault();
            }}
          />
        </div>
        
        
        <div className="form-group">
          <label>UF:</label>
          <input type="text" name="uf" value={formData.uf} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>CEP:</label>
          <input type="text" name="cep" value={formData.cep} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Pais:</label>
          <input type="text" name="pais" value={formData.pais} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Porte:</label>
          <input type="text" name="porte" value={formData.porte} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Bairro:</label>
          <input type="text" name="bairro" value={formData.bairro} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Número:</label>
          <input type="text" name="numero" value={formData.numero} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Município:</label>
          <input type="text" name="municipio" value={formData.municipio} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Logradouro:</label>
          <input type="text" name="logradouro" value={formData.logradouro} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>CNAE Fiscal:</label>
          <input type="number" name="cnae_fiscal" value={formData.cnae_fiscal} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Complemento:</label>
          <input type="text" name="complemento" value={formData.complemento} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>Razão Social:</label>
          <input type="text" name="razao_social" value={formData.razao_social} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Nome Fantasia:</label>
          <input type="text" name="nome_fantasia" value={formData.nome_fantasia} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Capital Social (R$):</label>
          <input
            type="text"
            name="capital_social"
            value={(() => {
              let digits = (typeof formData.capital_social === 'string' ? formData.capital_social : '').replace(/\D/g, '');
              if (!digits) return 'R$ 0,00';
              let intVal = parseInt(digits, 10);
              let cents = intVal % 100;
              let reais = Math.floor(intVal / 100);
              return `R$ ${reais.toLocaleString('pt-BR')},${cents.toString().padStart(2, '0')}`;
            })()}
            style={{
              textAlign: 'right',
              fontVariantNumeric: 'tabular-nums'
            }}
            onChange={() => {}}
            onKeyDown={e => {
              if (e.ctrlKey || e.metaKey || e.altKey) return;
              if (e.key === 'Backspace') {
                const prev = typeof formData.capital_social === 'string' ? formData.capital_social : '';
                const newDigits = prev.slice(0, -1);
                setFormData({ ...formData, capital_social: newDigits });
                e.preventDefault();
                return;
              }
              if (/^[0-9]$/.test(e.key)) {
                const prev = typeof formData.capital_social === 'string' ? formData.capital_social : '';
                if (prev.length < 13) {
                  setFormData({ ...formData, capital_social: prev + e.key });
                }
                e.preventDefault();
                return;
              }
              e.preventDefault();
            }}
          />
        </div>
        <div className="form-group">
          <label>DDD Telefone 1:</label>
          <input type="text" name="ddd_telefone_1" value={formData.ddd_telefone_1} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>DDD Telefone 2:</label>
          <input type="text" name="ddd_telefone_2" value={formData.ddd_telefone_2} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Representante Legal 1:</label>
          <input type="text" name="representante_legal_1" value={formData.representante_legal_1} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>CPF Representante Legal 1:</label>
          <input type="text" name="cpf_representante_legal_1" value={formData.cpf_representante_legal_1} onChange={handleChange} placeholder="000.000.000-00" />
        </div>
        <div className="form-group">
          <label>Representante Legal 2:</label>
          <input type="text" name="representante_legal_2" value={formData.representante_legal_2} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>CPF Representante Legal 2:</label>
          <input type="text" name="cpf_representante_legal_2" value={formData.cpf_representante_legal_2} onChange={handleChange} placeholder="000.000.000-00" />
        </div>
        <div className="form-group">
          <label>Natureza Jurídica:</label>
          <input type="text" name="natureza_juridica" value={formData.natureza_juridica} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Opção pelo Simples:</label>
          <input type="checkbox" name="opcao_pelo_simples" checked={formData.opcao_pelo_simples} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>CNAE Fiscal Descrição:</label>
          <input type="text" name="cnae_fiscal_descricao" value={formData.cnae_fiscal_descricao} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Descrição Situação Cadastral:</label>
          <input type="text" name="descricao_situacao_cadastral" value={formData.descricao_situacao_cadastral} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Descrição Identificador Matriz/Filial:</label>
          <input type="text" name="descricao_identificador_matriz_filial" value={formData.descricao_identificador_matriz_filial} onChange={handleChange} />
        </div>

        {/* Novos campos adicionados */}
        <div className="form-group">
          <label>Origem do Lead:</label>
          <select 
            name="origem_lead" 
            value={formData.origem_lead} 
            onChange={handleChange}
            className="select-input"
          >
            <option value="" disabled>Selecione a origem do lead</option>
            <option value="google busca orgânica">Google Busca Orgânica</option>
            <option value="google ADS">Google ADS</option>
            <option value="instagram orgânico">Instagram Orgânico</option>
            <option value="instagram tráfego pago">Instagram Tráfego Pago</option>
            <option value="TikTok">TikTok</option>
            <option value="prospecção comercial">Prospecção Comercial</option>
            <option value="indicação consultor financeiro">Indicação Consultor Financeiro</option>
            <option value="indicação cliente">Indicação Cliente</option>
            <option value="indicação cliente - consultor">Indicação cliente - consultor</option>
            <option value="indicação cliente - comercial">Indicação cliente - comercial</option>
            <option value="network hygor">Network Hygor</option>
            <option value="indicação parceiro">Indicação Parceiro</option>
            <option value="evento">Evento</option>
            <option value="evento pela fast">Evento pela Fast</option>
          </select>
        </div>
        <div className="form-group">
          <label>Data Reajuste Financeiro:</label>
          <input
            type="date"
            name="data_reajuste_financeiro"
            value={formData.data_reajuste_financeiro || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label>Porcentagem Reajuste Financeiro (%):</label>
          <input type="number" name="porcentagem_reajuste_financeiro" value={formData.porcentagem_reajuste_financeiro} onChange={handleChange} step="0.01" />
        </div>
        <div className="form-group">
          <label>Empresa Contratada:</label>
          <select name="empresa_contratada" value={formData.empresa_contratada} onChange={handleChange} className="select-input">
            <option value="" disabled>Selecione a empresa</option>
            <option value="Prise">Prise</option>
            <option value="Fast">Fast</option>
          </select>
        </div>
        <div className="form-group">
          <label>Vencimento Fatura 1 (Dia do Mês):</label>
          <input
            type="number"
            name="vencimento_fatura_1"
            value={formData.vencimento_fatura_1}
            onChange={handleChange}
            min="1"
            max="31"
            placeholder="Dia (1-31)"
          />
        </div>
        <div className="form-group">
          <label>Vencimento Fatura 2 (Dia do Mês):</label>
          <input
            type="number"
            name="vencimento_fatura_2"
            value={formData.vencimento_fatura_2}
            onChange={handleChange}
            min="0"
            max="31"
            placeholder="Dia (0-31)"
          />
        </div>
        <div className="form-group">
          <label>Observação Fatura:</label>
          <textarea 
            name="observacao_fatura" 
            value={formData.observacao_fatura} 
            onChange={handleChange}
            rows={3}
          />
        </div>
        <div className="form-group">
          <label>Indicação do Lead:</label>
          <input type="text" name="indicacao_lead" value={formData.indicacao_lead} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Comissão Indicação (%):</label>
          <input type="number" name="comissao_indicacao" value={formData.comissao_indicacao} onChange={handleChange} step="0.01" min="0" max="100" />
        </div>
        <div className="form-group">
          <label>Comissão Fechamento (%):</label>
          <input type="number" name="comissao_fechamento" value={formData.comissao_fechamento} onChange={handleChange} step="0.01" min="0" max="100" />
        </div>







      {/* <div className="form-row">
        <h1 className="form-title">Contratos</h1>


        {contratos.length > 0 && (
          <><div className="contratos-section">
            <h2>Contratos</h2>
            {contratos.map((contrato) => (
              <button
                key={contrato.id}
                type="button"
                className="contrato-button"
                onClick={() => window.open(contrato.linkArquivo, '_blank')}
              >
                {contrato.nomeArquivo}
              </button>
            ))}
          </div>
            <button type="submit" className="submit-button">Cadastrar</button>
          </>
        )}
      </div> */}

      <div className="form-row">
        <button type="submit" className="submit-button" disabled={!canRegisterClient}>
          Cadastrar
        </button>
        {!canRegisterClient && (
          <p style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>
            Apenas Developer, Gestor, Diretor e Comercial podem cadastrar novos clientes.
          </p>
        )}
      </div>
    </form>
  );
};

export default Cadastro;